import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Loader from '../../Loader';
import { Request } from '../../../helpers/request';

export default function LocalLoader({
  defIndustry,
  defSubIndustry,
  defLocations,
  defCurrentStep,
}) {
  const { currentStep, data: { industry,
    subIndustry,
    locations
  } } = useSelector(state => state.createPersona);

  const newStep = defCurrentStep || currentStep;
  const newSubIndustry =  defSubIndustry || defSubIndustry == null  ? defSubIndustry : subIndustry

  useEffect(() => {
    if (newStep === 3) {
      Request({
        method: 'POST',
        url: '/personas',
        data: {
          industry: defIndustry || industry,
          subIndustry: newSubIndustry,
          locations: defLocations || locations
        }
      }).then(response => {
        window.location.replace(`/personas/${response.id}`)
      }, error => {
        window.location.replace('/')
      });
    }
  }, [newStep]);

  return (
    <>
      {newStep === 3 && <Loader />}
    </>
  )
}
